import { useDashboardContext } from "../context/dashboard.contex";

const useDashboard = () => {
  return useDashboardContext();
};

export { useDashboard };